import { ISpecialistPersonalCardProps } from '../interfaces/ISpecialistCardProps';
import { ReactElement } from 'react';
import styles from './SpecialistPersonalCard.module.scss';
import { PreviewListImage } from '../../../3_features';
import { configMedia } from '../../SpecialistCard/ui/config/configMedia';
import SpecInfo from './components/SpecInfo';
import { EYandexPage } from '../../../1_shared/api/services/configs/interfaces/EYandexConfigs';
import { ISlot } from '../../../1_shared/config/interfaces/ISlot';
import { RoutePath } from '../../../1_shared/config/routes';
import { useNavigate } from 'react-router-dom';

/*
 * NOTE: Компонент будет пока использоваться для страница специалиста,
 * поскольку нет четкой информации о том, будет ли он переиспользоваться на странице специалистов, как это было ранее или нет
 */
const SpecialistPersonalCard = ({
  spec,
}: ISpecialistPersonalCardProps): ReactElement => {
  const navigate = useNavigate();

  const onSubmit = (data?: ISlot) => {
    navigate(RoutePath.ORDER, {
      state: { id: spec.id, slot: data || spec.slots[0] },
    });
  };

  const media = spec.mediaContentResponse?.length
    ? [
        ...spec.mediaContentResponse.sort((a, b) => {
          if (a.isPrimary && !b.isPrimary) return -1;
          if (!a.isPrimary && b.isPrimary) return 1;
          return 0;
        }),
      ]
    : [configMedia];

  return (
    <div className={styles.container}>
      <PreviewListImage media={media} />
      <SpecInfo
        specialist={spec}
        pageType={EYandexPage.Spec}
        onChange={onSubmit}
      />
    </div>
  );
};

export default SpecialistPersonalCard;
